/**
 * V1.1 Task 4 — pure presentational sub-component for the per-prefix
 * orphan count breakdown.
 */

import type { OrphanAuditReport } from "../../../api/admin-storage-orphan-audit";
import { tableStyles as ts } from "../../../components/TableParts";
import { t } from "../../../i18n";
import { auditStyles as styles } from "./storage-orphan-audit-helpers";

export function PrefixBreakdownTable({
  entries,
}: {
  entries: NonNullable<OrphanAuditReport["latest_run"]>["prefix_breakdown"];
}): React.JSX.Element {
  if (entries.length === 0) {
    return (
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>
          {t("storage_orphan_audit.prefix_breakdown")}
        </h2>
        <p style={styles.emptyText}>
          {t("storage_orphan_audit.no_prefix_data")}
        </p>
      </section>
    );
  }
  return (
    <section style={styles.card}>
      <h2 style={styles.cardTitle}>
        {t("storage_orphan_audit.prefix_breakdown")}
      </h2>
      <table style={ts.table}>
        <thead>
          <tr>
            <th style={ts.th}>{t("storage_orphan_audit.col_prefix")}</th>
            <th style={ts.th}>{t("storage_orphan_audit.col_count")}</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e.prefix} style={ts.row}>
              <td style={{ ...ts.td, ...styles.mono }}>{e.prefix}</td>
              <td style={ts.td}>{e.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
